import React from "react"
import classNames from "classnames";
import useMediaQuery from "./hooks/useMediaQuery"
import styles from "style.css";
import Animate from "components/Animate";
// import * as THREE from "three";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useEffect, useState } from "react";
import TetScene from "components/TetScene";
import ReactGA from "react-ga4";

export default function App() {

  // const trackingId = "G-CDDZMKNF1Q"; //Google Analytics tracking ID R&D
  const trackingId = "G-3L1CJEKYJR"; //Google Analytics tracking ID Production


  ReactGA.initialize(trackingId);

  const [loading, setLoading] = useState(true);
  // read config.json and get env vars from it

  async function fetchConfig() {
    //await new Promise(resolve => setTimeout(resolve, 3000))
    await fetch('./config.json', {
      method: 'get',
      dataType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(config => {
        window.config = config;
        setLoading(loading => false);
      });// R&D Google Analytics tracking ID

  }
  useEffect(() => {
    fetchConfig();
  }, []);

  return (
    <div className="app-div">
      <BrowserRouter>
        <Routes>
          <Route path={"/"} element={
            <div className="inner-app-div">
                <TetScene  />
            </div>
          }>
          </Route>
        </Routes>
      </BrowserRouter>

    </div>
  )
}